import { Chip, type ChipProps } from '@mui/material';
import { MHMTypography, type MHMTypographyProps } from './MHMTypography';

export type MHMLabelProps = ChipProps & {
  labelProps?: MHMTypographyProps;
};

export function MHMLabel(props: MHMLabelProps) {
  const { label, color, sx, ...rest } = props;
  const { labelProps, ...chipProps } = rest;

  let labelTextColour = '';
  if (labelProps?.color) {
    labelTextColour = labelProps.color;
  } else if (rest.variant === 'filled') {
    labelTextColour = 'highlight';
  }

  return (
    <Chip
      variant="outlined"
      color={color ?? 'primary'}
      data-testid={`mhm-label-${label}`}
      sx={{
        borderRadius: '5px',
        border: '2px solid',
        padding: '0.2rem 0',
        ...sx,
      }}
      label={
        <MHMTypography
          {...(labelTextColour && { color: labelTextColour })}
          {...labelProps}
        >
          {label}
        </MHMTypography>
      }
      {...chipProps}
    />
  );
}
